import { Link } from "react-router-dom";

// Recreated Market Street Ventures wordmark logo
export default function Logo({ light = false, className = "" }) {
  const dark = light ? "#ffffff" : "#1a2540";
  const blue = "#1b75bc";
  return (
    <Link to="/" className={`inline-flex flex-col items-center leading-none select-none ${className}`}>
      <div className="flex items-center font-heading font-600" style={{ letterSpacing: "0.02em" }}>
        <span
          className="text-[26px] md:text-[30px] font-bold tracking-tight"
          style={{ color: dark, fontFamily: "Oswald, sans-serif" }}
        >
          MARKET
        </span>
        <span className="mx-[6px] relative inline-flex items-center justify-center">
          <img
            src="/msv-circle.png"
            alt="Market Street Ventures emblem"
            className="w-[24px] h-[24px] md:w-[26px] md:h-[26px] -mt-0.5 object-contain"
          />
        </span>
        <span
          className="text-[26px] md:text-[30px] font-bold tracking-tight"
          style={{ color: dark, fontFamily: "Oswald, sans-serif" }}
        >
          STREET
        </span>
      </div>
      <span
        className="text-[11px] md:text-[13px] tracking-[0.55em] pl-[0.55em] mt-0.5"
        style={{ color: blue, fontFamily: "Oswald, sans-serif", fontWeight: 400 }}
      >
        VENTURES
      </span>
    </Link>
  );
}
